import React, { useState } from "react";
import "./Help.css";
import { BiSupport } from "react-icons/bi";

function Help() {
  const [showContactForm, setShowContactForm] = useState(false);

  const submitSupport = (e) => {
    e.preventDefault();
    alert(
      "Your support request has been submitted. Our team will contact you shortly."
    );
    e.target.reset();
    setShowContactForm(false);
  };
  return (
    <div>
      <h1 className="dashboard-heading">
        <BiSupport /> Support
      </h1>

      {/* <div className="help-container"> */}

      <main className="help-main">
        {/* Contact Support button or form at the bottom */}
        <div style={{ marginTop: "3rem" }}>
          {showContactForm ? (
            <section className="support-form">
              <h1>Contact Support</h1>
              <form onSubmit={submitSupport}>
                <label>
                  Name *
                  <input type="text" required />
                </label>

                <label>
                  Email *
                  <input type="email" required />
                </label>

                <label>
                  Subject *
                  <input type="text" required />
                </label>

                <label>
                  Description *
                  <textarea rows="5" required />
                </label>

                <label>
                  Attachment
                  <input type="file" />
                </label>

                <div className="button-row">
                  <button type="submit">Submit</button>
                  <button
                    type="button"
                    onClick={() => setShowContactForm(false)}
                    className="cancel-button"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          ) : (
            <button
              className="contact-button"
              onClick={() => setShowContactForm(true)}
            >
              Contact Support
            </button>
          )}
        </div>

        {/* === Getting Started === */}
        <section className="help-section">
          <h2>Getting Started</h2>
          <div className="topic">
            <h3>How to Create an Account</h3>
            <p>
              To create an account, click on <strong>Sign Up</strong> on the
              homepage. Fill in your name, email, password, and select whether
              you are a customer or vendor. Then confirm your email to activate
              the account.
            </p>
          </div>
        </section>

        {/* === Orders === */}
        <section className="help-section">
          <h2>Orders</h2>
          <div className="topic">
            <h3>Order Tracking in Vendor Dashboard</h3>
            <p>Vendors can track orders using the Orders tab:</p>
            <ul>
              <li>View Order ID, Customer Name, Order Status</li>
              <li>
                Track order status: Pending → Confirmed → Shipped → Delivered
              </li>
              <li>Access invoice download and shipping label options</li>
              <li>Check courier tracking link for real-time delivery status</li>
              <li>Keep shipping status updated to avoid auto-cancellations.</li>
            </ul>
          </div>
          <div className="topic">
            <h3>Managing Orders</h3>
            <p>Steps to manage incoming orders:</p>
            <ol>
              <li>Confirm Order</li>
              <li>Accept the order within SLA (usually 24 hrs)</li>
              <li>Assign a courier if using your own shipping</li>
              <li>Pack & Ship</li>
              <li>Print invoice and shipping label</li>
              <li>Pack securely and hand over to courier partner</li>
              <li>Update Shipping Status</li>
              <li>Delivery & Completion</li>
            </ol>
            Timely updates reduce returns and cancellations.
          </div>
        </section>

        {/* === Payments === */}
        <section className="help-section">
          <h2>Payments</h2>
          <div className="topic">
            <h3>Viewing Payment Status</h3>
            <p>Navigate to Dashboard &gt; Payments to see:</p>
            <ul>
              <li>Order-wise earnings and deductions</li>
              <li>Upcoming payouts</li>
              <li>Downloadable payment reports and invoices</li>
            </ul>
          </div>
          <div className="topic">
            <h3>Mandatory Fields for Payments Setup</h3>
            <ul>
              <li>Bank Account Number</li>
              <li>Account Holder Name</li>
              <li>IFSC Code</li>
              <li>PAN Number</li>
              <li>GSTIN (if applicable)</li>
              <li>Branch Address</li>
            </ul>
          </div>
          <div className="topic">
            <h3>Common Payment Issues & Resolutions</h3>
            <table className="help-table">
              <thead>
                <tr>
                  <th>Issue</th>
                  <th>Resolution</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Payment delays</td>
                  <td>Confirm return window is closed; check payout date.</td>
                </tr>
                <tr>
                  <td>Incorrect bank details</td>
                  <td>Update info in Settings &gt; Bank Information.</td>
                </tr>
                <tr>
                  <td>GST mismatch</td>
                  <td>
                    Ensure correct GSTIN and HSN codes in product listings.
                  </td>
                </tr>
                <tr>
                  <td>Missing payout</td>
                  <td>Contact support with transaction/order details</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* === Products === */}
        <section className="help-section">
          <h2>Products</h2>
          <div className="topic">
            <h3>Adding a New Product</h3>
            <p>
              When listing a new product, vendors are required to fill out the
              following fields:
            </p>
            <ul>
              <li>Product Title</li>
              <li>Category</li>
              <li>Brand</li>
              <li>Price</li>
              <li>MRP</li>
              <li>Stock Quantity</li>
              <li>Product Description</li>
              <li>Primary Image</li>
              <li>Shipping Weight</li>
              <li>Dimensions</li>
              <li>HSN Code</li>
              <li>GST Percentage</li>
            </ul>
          </div>
          <div className="topic">
            <h3>Editing Existing Products</h3>
            <div>
              <ul>
                <li>Navigate to Products &gt; My Listings</li>
                <li>Click Edit on any product</li>
                <li>You can modify: price, stock, description, and images</li>
                <li>Changes reflect within 15 minutes (after moderation)</li>
              </ul>
            </div>
          </div>
          <div className="topic">
            <h3>Product Visibility Issues</h3>
            <div>
              <ul>
                <li>Ensure it's published and has stock</li>
                <li>Check moderation status</li>
                <li>Verify brand/GST compliance</li>
                <li>Check for missing fields</li>
                <li>Contact support if unresolved</li>
              </ul>
            </div>
          </div>
        </section>

        {/* === Technical Support === */}
        <section className="help-section">
          <h2>Technical Support</h2>
          <div className="topic">
            <h3>Password Reset</h3>
            <p>
              Click “Forgot Password” on the login page. Enter your email to
              receive a reset link.
            </p>
          </div>
          <div className="topic">
            <h3>Bug Reporting</h3>
            <p>
              Use the “Report an Issue” form in the vendor dashboard. Include
              steps and screenshots.
            </p>
          </div>
          <div className="topic">
            <h3>App & Dashboard Issues</h3>
            <p>
              Clear cache, use supported browsers, disable extensions. Contact
              support if needed.
            </p>
          </div>
        </section>

        {/* === Account Management === */}
        <section className="help-section">
          <h2>Account Management</h2>
          <div className="topic">
            <h3>Managing Profile & Business Info</h3>
            <p>
              Go to Dashboard &gt; Account Settings to update business info and
              tax details.
            </p>
          </div>
          <div className="topic">
            <h3>Changing Password & Security</h3>
            <p>
              Update password in Dashboard &gt; Security Settings. Enable 2FA
              for more protection.
            </p>
          </div>
          <div className="topic">
            <h3>Notifications & Alerts</h3>
            <p>
              Customize email/SMS alerts from Notification Settings to stay
              informed.
            </p>
          </div>
        </section>

        {/* === Shipping === */}
        <section className="help-section">
          <h2>Shipping & Delivery</h2>
          <div className="topic">
            <h3>Shipping Policies & Options</h3>
            <p>
              Choose between self-fulfillment or platform logistics. Provide
              accurate shipping details.
            </p>
          </div>
          <div className="topic">
            <h3>Returns & Exchanges</h3>
            <p>
              Approve/reject return requests under Orders &gt; Returns.
              Communicate clearly.
            </p>
          </div>
          <div className="topic">
            <h3>Packaging Guidelines</h3>
            <p>
              Use strong boxes, padding, and clear labels. Follow platform
              standards for safety.
            </p>
          </div>
        </section>
      </main>
      {/* </div> */}
    </div>
  );
}

export default Help;
